import React from "react";
import "./style.css";
import ReactDOMClient from "react-dom/client";
import {
    createBrowserRouter,
    RouterProvider,
  } from "react-router-dom";
import { LandingPage } from "./screens/LandingPage";
import { ClientsPage } from "./screens/ClientsPage";
import { JobsPage } from "./screens/JobsPage";
import { AboutUsPage } from "./screens/AboutUS";
import {PrivacyPage } from "./screens/Privacy";
import { TestimonialsPage } from "./screens/Testimonials";
import ScrollToHashElement from "@cascadia-code/scroll-to-hash-element";


const router = createBrowserRouter([
    {
      path: "/",
      element: <LandingPage />,
    },
    {
        path: "/talent",
        element: <ClientsPage />,
      },
    {
        path: "/jobs",
        element: <JobsPage />,
    },
    {
      path: "/about-us",
      element: <AboutUsPage />,
    },
    {
      path: "/testimonials",
      element: <TestimonialsPage />,
    },
    {
      path: "/privacy",
      element: <PrivacyPage />,
    },
  ]);

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);
root.render(
    <React.StrictMode>
      <ScrollToHashElement />
        <RouterProvider router={router} />
    </React.StrictMode>
);
